export const logError = (
  error: Error | { name: string; message: string },
  errorInfo?: never
): void => {
  // biome-ignore lint/suspicious/noConsole: surface errors in the web inspector
  console.error(error, errorInfo);
};
